
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/meu3catinfo",
      function () {
        return require("private-next-pages/3catinfo/meu3catinfo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/meu3catinfo"])
      });
    }
  